import { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import work1 from "../imgs/work1.jpg";
import work2 from "../imgs/work2.jpg";
import work3 from "../imgs/work3.jpg";
import work4 from "../imgs/work4.jpg";
import work5 from "../imgs/work5.jpg";
import work6 from "../imgs/work6.jpg";

const images = [work1, work2, work3, work4, work5, work6];
const slides = images.map(src => ({ src }));

export default function WorkSlider() {
  const [index, setIndex] = useState(-1);

  return (
    <section className="py-4">
      <div className="container py-4">
        <h2 className="text-center display-5 fw-bold mb-5 text-white">Примеры наших работ</h2>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation, Pagination, A11y, FreeMode]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="rounded-4 overflow-hidden"
          >
            {images.map((src, i) => (
              <SwiperSlide key={i}>
                <div
                  onClick={() => setIndex(i)}
                  className="position-relative cursor-pointer"
                  style={{ paddingBottom: "75%", height: 0, overflow: "hidden" }}
                >
                  <img
                    src={src}
                    alt={`work-${i+1}`}
                    className="position-absolute w-100 h-100"
                    style={{ objectFit: "cover", top: 0, left: 0 }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>

      <Lightbox
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        slides={slides}
      />
    </section>
  );
}